export const NotificationType = {
  COMMENT_MENTION: 'COMMENT_MENTION',
  COMMENT_REPLY: 'COMMENT_REPLY',
  COMMENT_THREAD_REPLY: 'COMMENT_THREAD_REPLY',
  EXPORT_READY: 'EXPORT_READY',
} as const;

export type NotificationType =
  (typeof NotificationType)[keyof typeof NotificationType];
